import React, { useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteMessagingContent } from '../../../../store/slices/register';
const DeleteConfirmationRegister = (props) => {
    const { id } = useParams();
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const { deleteMessagingContentData, deleteMessagingContentLoading, deleteMessagingContentFailure } = useSelector((state) => state?.registersReducer)
    useEffect(() => {
        if (id) {
            if (id) {
                dispatch(deleteMessagingContent(id));
            }
        }
    }, [])


    useEffect(() => {
        if (deleteMessagingContentFailure || deleteMessagingContentData) {
            setTimeout(() => {
                navigate(-1)
            }, 2000)
        }
    }, [deleteMessagingContentData, deleteMessagingContentFailure])

    return (

        <div className={"permission_denied"}>
            {(deleteMessagingContentLoading) ?
                <>
                    {deleteMessagingContentLoading &&
                        <>
                            <h1>Deleting Messaging...</h1>
                        </>
                    }
                </>
                :
                <>
                    {
                        (deleteMessagingContentData) &&
                        <div>
                            <h1>Deleted SuccessFully</h1>
                            <h5>Thank You!</h5>
                        </div>
                    }
                    {
                        (deleteMessagingContentFailure) &&
                        <div className='text-danger'>
                            <h1>Deletion Failed</h1>
                            <h5>Please Try Again</h5>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default DeleteConfirmationRegister